import React, { useRef, useCallback, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FaFacebook, FcGoogle } from 'react-icons/all';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import getValidarionErrors from '../../utils/getValidationErrors';

import Input from '../../components/Input';
import Button from '../../components/Button';

import logoImg from '../../assets/logo.png';

import { forgotPasswordFunction } from '../../services/firebase';

import {
  Container,
  Content,
  Background,
  AnimationContainer,
  FacebookButton,
  GoogleButton,
  ButtonContent,
  FormLogin,
  ForgotPassword,
  ForgotPasswordContainer,
} from './styles';

interface SingInFormData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [forgotPassword, setForgotPassword] = useState(false);

  const { singIn, singInFacebook, singInGoogle } = useAuth();
  const { addToast } = useToast();

  const handleSubmitResetPassword = useCallback(async (data: any) => {
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
          .required('Email obrigatório')
          .email('Email Obrigatório'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await forgotPasswordFunction(data.email);

      addToast({
        type: 'success',
        title: 'Verifique seu email para redefinir sua senha',
      });

      setForgotPassword(false);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidarionErrors(err);
        formRef.current?.setErrors(errors);

        return;
      }

      addToast({
        type: 'info',
        title: 'erro na autenticação',
        description: 'Ocorreu um erro ao fazer login, cheque as credenciais',
      });
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: SingInFormData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Email Obrigatório'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await singIn({
          email: data.email,
          password: data.password,
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidarionErrors(err);
          console.log('Error ---', err)
          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'info',
          title: 'erro na autenticação',
          description: 'Ocorreu um erro ao fazer login, cheque as credenciais',
        });
      }
    },
    [singIn, addToast],
  );

  const HandleSingInGoogle = useCallback(async () => {
    try {
      await singInGoogle();
    } catch (e) {
      addToast({
        type: 'error',
        title: 'Erro ao logar',
        description: e.message,
      });
    }
  }, []);

  const HandleSingInFacebook = useCallback(async () => {
    try {
      await singInFacebook();
    } catch (e) {
      addToast({
        type: 'error',
        title: 'Erro ao logar',
        description: e.message,
      });
    }
  }, []);

  return (
    <Container>
      <Content>
        {forgotPassword ? (
          <AnimationContainer>
            <img src={logoImg} alt="QAgil" />
            <ForgotPasswordContainer>
              <FormLogin onSubmit={handleSubmitResetPassword} ref={formRef}>
                <Input
                  name="email"
                  icon={FiMail}
                  type="text"
                  placeholder="E-Mail"
                />
                <Button type="submit">Redefinir Senha</Button>
                <ForgotPassword onClick={() => setForgotPassword(false)}>
                  Voltar
                </ForgotPassword>
              </FormLogin>
            </ForgotPasswordContainer>
          </AnimationContainer>
        ) : (
          <>
            <AnimationContainer>
              <img src={logoImg} alt="QAgil" />
              <FormLogin onSubmit={handleSubmit} ref={formRef}>
                <h1>Faça Seu Logon</h1>

                <Input
                  name="email"
                  icon={FiMail}
                  type="text"
                  placeholder="E-Mail"
                />
                <Input
                  name="password"
                  icon={FiLock}
                  type="password"
                  placeholder="Senha"
                />

                <Button type="submit">Entrar</Button>

                <ForgotPassword onClick={() => setForgotPassword(true)}>
                  Esqueci minha senha
                </ForgotPassword>
              </FormLogin>

              <Link to="/singup">
                <FiLogIn />
                Criar Conta
              </Link>
              <FacebookButton onClick={() => HandleSingInFacebook()}>
                <ButtonContent>
                  <FaFacebook size={30} />
                  Login com Facebook
                </ButtonContent>
              </FacebookButton>
              <GoogleButton onClick={() => HandleSingInGoogle()}>
                <ButtonContent>
                  <FcGoogle size={30} />
                  Login com Google
                </ButtonContent>
              </GoogleButton>
            </AnimationContainer>
          </>
        )}
      </Content>
      <Background />
    </Container>
  );
};

export default SignIn;
